module.exports = __webpack_public_path__ + "img/checkmark.c36cafc9.svg";